import { render } from "./HomeView.vue?vue&type=template&id=f922b044&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=f922b044&scoped=true&lang=css"

import exportComponent from "/home/gruxxki/dev_web/POC/tombo-random/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f922b044"]])

export default __exports__